import { useCallback, useEffect, useState } from "react";

import { getNetworkStateAsync } from "expo-network";

import { NetworkAnalyticsEvent } from "@/constants/analytics/Network";
import { useAnalytics } from "@/services/Analytics";
import useAppMonitor from "@/services/AppMonitor";

const useDeviceNetworkState = () => {
  const [isDeviceOnline, setIsDeviceOnline] = useState<boolean | undefined>(
    true,
  );

  const { track } = useAnalytics();
  const { captureException } = useAppMonitor();

  // when expo is upgraded to expo 53+, this needs to be updated to use the useNetworkState hook
  const checkNetworkState = useCallback(async () => {
    try {
      const currentNetworkState = await getNetworkStateAsync();
      setIsDeviceOnline(
        currentNetworkState.isConnected &&
          currentNetworkState.isInternetReachable,
      );
    } catch (error: unknown) {
      captureException(error);
      // Fallback to offline state if network check fails
      setIsDeviceOnline(false);
    }
  }, [captureException]);
  useEffect(() => {
    void checkNetworkState();

    // Set up periodic network state checking
    const interval = setInterval(() => {
      void checkNetworkState();
    }, 5000);

    return () => clearInterval(interval);
  }, [checkNetworkState]);

  useEffect(() => {
    track(NetworkAnalyticsEvent.NetworkStatusChanged, {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "Is Online": isDeviceOnline,
    });
  }, [isDeviceOnline, track]);

  return {
    isDeviceOnline,
  };
};

export default useDeviceNetworkState;
